import React, { useState, useRef, useMemo } from 'react';
import cn from 'classnames';
import ReactSwipe from 'react-swipe';
import Dots from '@wix/da-ds/pkg/pagination/Dots';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import s from './SwipeSlider.scss';
const MAX_CHILDREN_COUNT = 5;
const SwipeSlider = ({ startSlide = 0, indicatorsClassName, children })=>{
    const [activeIndex, setActiveIndex] = useState(startSlide);
    const reactSwipeRef = useRef(null);
    const items = React.Children.count(children) > MAX_CHILDREN_COUNT ? React.Children.toArray(children).slice(0, MAX_CHILDREN_COUNT) : React.Children.toArray(children);
    // override swipe styles to use flexbox instead of floats which give us troubles with vertical stretching
    const swipeStyle = useMemo(()=>({
            container: {
                overflow: 'hidden'
            },
            wrapper: {
                position: 'relative',
                display: 'flex',
                alignItems: 'stretch',
                width: `${100 * items.length}%`
            },
            child: {
                position: 'relative',
                left: startSlide > 0 ? `-${100.0 / items.length * startSlide}%` : 0,
                flexBasis: `${100.0 / items.length}%`,
                flexShrink: 0,
                transitionProperty: 'transform'
            }
        }), [
        startSlide,
        items
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: s['root']
    }, /*#__PURE__*/ React.createElement(ErrorBoundary, {
        debugComponent: "SwipeSlider"
    }, /*#__PURE__*/ React.createElement(ReactSwipe, {
        ref: (swipeRef)=>reactSwipeRef.current = swipeRef,
        childCount: items.length,
        style: swipeStyle,
        swipeOptions: {
            startSlide,
            continuous: false,
            callback: (index)=>{
                // this call fixes some jerkyness possibly caused by re-render before swipe ends
                window.requestAnimationFrame(()=>{
                    setActiveIndex(index);
                });
            }
        }
    }, items.map((child, index)=>/*#__PURE__*/ React.createElement("div", {
            key: child ? child['key'] : index
        }, child))), items.length > 1 && /*#__PURE__*/ React.createElement("div", {
        className: cn(s['indicators'], indicatorsClassName)
    }, /*#__PURE__*/ React.createElement(Dots, {
        total: items.length,
        current: activeIndex,
        onClick: (index)=>{
            setActiveIndex(index);
            reactSwipeRef.current && reactSwipeRef.current.slide(index, 0);
        }
    }))));
};
SwipeSlider.displayName = 'SwipeSlider';
export default SwipeSlider;
